import empty from '@/assets/images/empty.png'
import {Image} from "@arco-design/web-react";
import React from "react";
const Empty = () => {
  return (
    <div>
      <Image preview={false} width={81} height={58} src={empty}></Image>
      <div style={{ textAlign: 'center', color: '#999999', fontSize: '14px', }}>暂无数据</div>
    </div>
  );
}
export default Empty
